<template>
    <div>
        <b-card class="mb-5">
            <b-card-body>
                <h4 class="mb-4">Delete Session</h4>

                <p>
                    NOTE: This is a permanent action.</p>
                <div class="mt-5">
                    <b-button variant="danger" @click="deleteSess()"><i class="fas fa-trash mr-3"></i>Delete Session</b-button>
                </div>
            </b-card-body>
        </b-card>
    </div>

</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "Tools",
        props: ['id', 'sessId'],
        data: function () {
            return {
                registration: {
                    conference: {}
                },
                processing: false
            }
        },
        methods: {
            ...mapActions(['deleteSession']),

            deleteSess() {
                if (window.confirm('Are you sure you want to delete this session?  This is a permanent action.')) {
                    this.deleteSession(this.sessId).then(() => {
                        this.$router.push({name: 'conf-sessions', params: {id: this.id}});
                    });
                }
            }
        },
        mounted: function () {

        }
    }
</script>

<style scoped>

</style>
